// src/components/DashboardLayout.js
import React from "react";
import { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from "react-router-dom";
import { FaUser, FaSignOutAlt, FaMoneyBillWave, FaUsers, FaAngleDoubleRight, FaAngleDoubleLeft, FaWallet, FaClipboardList } from "react-icons/fa";
import "./DashboardLayout.css";
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';


const DashboardLayout = ({ children, role }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/");
  };

  const [nickname, setNickname] = useState("");
  const location = useLocation();


  useEffect(() => {
    const fetchOfficer = async () => {
      const token = localStorage.getItem("token");
      if (!token) return;

      try {
        const decoded = jwtDecode(token);
        const officer_id = decoded.officer_id;

        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/officers/${officer_id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const officerData = res.data;
        setNickname(officerData.nickname);
      } catch (err) {
        console.error("Failed to fetch officer detail:", err);
      }
    };

    fetchOfficer();
  }, []);



  const [isCollapsed, setIsCollapsed] = useState(false);

  const handleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <div className="dashboard">
      <aside className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
        <h2 className={`logo ${isCollapsed ? 'collapsed' : ''}`}>Shaff HRIS</h2>
        <nav>
          <ul>
            <li className={location.pathname.includes("/dashboard") ? "active" : ""}>
              <Link to={`/${role}/dashboard`}>
                {isCollapsed ? <FaUser /> : <><FaUser /> Dashboard</>}
              </Link>
            </li>
            {role === "superadmin" && (
              <>
                <li className={location.pathname.includes("/superadmin/officers") ? "active" : ""}>
                  <Link to="/superadmin/officers">
                    {isCollapsed ? <FaUsers /> : <><FaUsers /> Officers</>}
                  </Link>
                </li>
                <li className={location.pathname.includes("/superadmin/salaries") ? "active" : ""}>
                  <Link to="/superadmin/salaries">
                    {isCollapsed ? <FaMoneyBillWave /> : <><FaMoneyBillWave /> Salaries</>}
                  </Link>
                </li>
                <li className={location.pathname.includes("/superadmin/finance") ? "active" : ""}>
                  <Link to="/superadmin/finance">
                    {isCollapsed ? <FaWallet /> : <><FaWallet /> Finance</>}
                  </Link>
                </li>
                <li className={location.pathname.includes("/superadmin/tasks") ? "active" : ""}>
                  <Link to="/superadmin/tasks">
                    {isCollapsed ? <FaClipboardList /> : <><FaClipboardList /> Tasks</>}
                  </Link>
                </li>
              </>
            )}
            {role === "officer" && (
              <>
                <li className={location.pathname.includes("/officer/salaries") ? "active" : ""}>
                  <Link to="/officer/salaries">
                    {isCollapsed ? <FaMoneyBillWave /> : <><FaMoneyBillWave /> Salaries</>}
                  </Link>
                </li>
                <li className={location.pathname.includes("/officer/tasks") ? "active" : ""}>
                  <Link to="/officer/tasks">
                    {isCollapsed ? <FaClipboardList /> : <><FaClipboardList /> Tasks</>}
                  </Link>
                </li>
              </>
            )}
            <li onClick={handleLogout} className="logout-btn">
              {isCollapsed ? <FaSignOutAlt /> : <><FaSignOutAlt /> Logout</>}
            </li>
          </ul>
        </nav>
        <div className="collapse-btn" onClick={handleCollapse}>
          {isCollapsed ? <FaAngleDoubleRight /> : <FaAngleDoubleLeft />}
        </div>
      </aside>

      <div className={`main-content ${isCollapsed ? 'collapsed' : ''}`}>
        <header className="topbar">
          <h3>Assalamualaikum, {nickname}</h3>
        </header>

        <main className="content">{children}</main>
      </div>
    </div>
  );
};

export default DashboardLayout;
